import React from "react";
// import styles from "./Services.module.scss";

import NrgPage from '../NrgPage.jsx';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import GenericHeader from './../../components/Header/GenericHeader.jsx';
import JourneyContinueBox from './../../components/JourneyContinueBox/JourneyContinueBox.jsx';
import SimpleTextBox from './../../components/SimpleTextBox/SimpleTextBox.jsx';
import PipedContentHeader from './../../components/PipedContentHeader/PipedContentHeader.jsx';
import UnderPipePanel from './../../components/UnderPipePanel/UnderPipePanel.jsx';
import PipedContentFooter from './../../components/PipedContentFooter/PipedContentFooter.jsx';
import IconListPanel from './../../components/IconListPanel/IconListPanel.jsx';
import Footer from './../../components/Footer/Footer.jsx';
import PageTransitioner from '../../components/PageTransitioner.jsx';

import ScrollItemManager from './../../utils/ScrollItemManager';
import { changePageTitle } from "../../utils/pageSetup/pageSetup.js";

class Services extends NrgPage {
    constructor(props) {
        super(props);

        this.page = 'services';

        this.state = {
            newsOpen: false
        };
    }
    componentDidMount() {
        changePageTitle(this.page);

        this.scrollItemManager = new ScrollItemManager();
        this.scrollItemManager.setup();
    }
    render() {
        return (
            <div className={[this.page, "container-fluid"].join(" ")}>
                <PageTransitioner page={this.page}>
                    {/* <ReactCSSTransitionGroup
                        transitionName="news"
                        transitionAppear={true}
                        transitionAppearTimeout={0}
                        transitionEnterTimeout={300}
                        transitionLeaveTimeout={300}>
                        {newsPanel}
                    </ReactCSSTransitionGroup> */}

                    <GenericHeader page={this.page} newsActions={this.newsActions} />

                    <SimpleTextBox page={this.page} />

                    <PipedContentHeader page={this.page} />
                    <UnderPipePanel page={this.page} section="qualitative" />
                    <IconListPanel page={this.page} section="qualitative" />
                    <UnderPipePanel page={this.page} section="quantitative" />
                    <IconListPanel page={this.page} section="quantitative" />
                    <UnderPipePanel page={this.page} section="storytelling" />
                    <IconListPanel page={this.page} section="storytelling" isLast={true} />
                    <PipedContentFooter />

                    <JourneyContinueBox nextPage="Expertise" nextPageHref="/expertise" />
                    <Footer />
                </PageTransitioner>
            </div>
        );
    }
}

export default Services;
